import axios from 'axios'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import { Utils } from '@saas/lib/toktokdoc-lib/web'
import 'moment/locale/fr'
import moment from 'moment-timezone'

moment.locale('fr')
moment.tz.setDefault('Europe/Paris')

class SlackNotifications {
    /**
     * @static
     * @async
     * @description send notification to slack
     * @param {string} objectId
     * @param {string} type
     * @param {string} message
     * @param {Boolean} throws
     * @returns {void}
     * @memberof SlackNotifications
     */
    static async sendNotification(objectId: any, type: any, message: any, throws: any) {
        if (!message) return
        try {
            const token = await Utils.getSessionToken()
            await axios.post(
                `${window._env_.REACT_APP_HDS_HOST}/notify`,
                {
                    type,
                    message,
                    id: objectId,
                },
                {
                    headers: {
                        'X-Session-Token': token,
                    },
                }
            )
            
        } catch (e) {
            if (throws) throw e
        }
    }

    /**
     * @static
     * @description
     * @param {Consultation} consultation
     * @returns {void}
     * @memberof SlackNotifications
     */
    static createPlannedConsultation(consultation: any) {
        let message

        try {
            let { speciality } = consultation.requiredExpert[0].extraHealthActivityInfo
            if (speciality) speciality = speciality.name

            message = `\`Création d'une téléconsultation prévue\` *Initiation Téléconsultation*
• ${consultation.healthCareService.name}
• ${speciality || ''} – ${consultation.objectId}
• PS requérant : ${consultation.careGiver.getFullName()} ${window._env_.REACT_APP_MANAGER_HOST}/users/${consultation.careGiver.id}
• PS requis : ${consultation.requiredExpert[0].getFullName()} ${window._env_.REACT_APP_MANAGER_HOST}/users/${consultation.requiredExpert[0].id}
• Date prévue : ${moment(new Date(consultation.initialAppointmentDate)).format('DD-MM-YYYY HH:mm')}`
        } catch (error) {
            console.log(error)
        }

        // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 3.
        this.sendNotification(`TLC-Preview-${consultation.objectId}`, 'TLC', message).catch((err) => console.log(err))
    }
}

export default SlackNotifications
